import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export function LeaveMeetingDialog({open, busy, onOpenChange, onLeave, onEnd}: {
  open: boolean; busy: boolean; onOpenChange: (open: boolean) => void;
  onLeave: () => void; onEnd: () => void;
}) {
  return <Dialog open={open} onOpenChange={value => { if (!busy) onOpenChange(value); }}>
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle>Bạn muốn rời phòng hay kết thúc cuộc họp?</DialogTitle>
        <DialogDescription>Rời phòng: những người khác tiếp tục họp và bạn có thể vào lại. Kết thúc cuộc họp: đóng phòng cho tất cả mọi người.</DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2 sm:flex-wrap">
        <Button type="button" variant="outline" disabled={busy} onClick={()=>onOpenChange(false)}>Hủy</Button>
        <Button type="button" variant="secondary" disabled={busy} onClick={onLeave}>Rời phòng</Button>
        <Button type="button" variant="destructive" disabled={busy} onClick={onEnd}>{busy ? 'Đang xử lý…' : 'Kết thúc cuộc họp'}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>;
}
